"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/** A checkbox that looks a little like an iOS Toggle https://developer.apple.com/design/human-interface-guidelines/components/selection-and-input/toggles/ */
var IosToggle = function (_a) {
    var checked = _a.checked, onChange = _a.onChange;
    return (react_1.default.createElement("label", { className: 'ios-switch' },
        react_1.default.createElement("input", { type: 'checkbox', checked: checked, onChange: function (event) { return onChange(event.target.checked); }, className: 'ios-switch-checkbox' }),
        react_1.default.createElement("span", { className: 'ios-switch-display' })));
};
exports.default = IosToggle;
